import { Button } from 'components/shared/Button';
import OTPInput from 'react-otp-input';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from 'components/layouts/AuthLayout';
import { Modal, notification } from 'antd';
import { useAuth } from "hooks";
import { Close } from "assets/svg/SvgIcons";
import { useMutation } from '@tanstack/react-query';
import { useResendVerificationEmailApi, verifyResetPasswordTokenApi } from 'services/api/authApi';

const VerifyEmailAuth = () => {
  const navigate = useNavigate();
  const [OTP, setOTP] = useState<string>("");
  const { setOTP: saveOTPToContext } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const email = localStorage.getItem('email') || localStorage.getItem('techrevolve_email') || "";
  ;

  useEffect(() => {
    setIsModalVisible(true);
  }, []);


  const renderInput = ({ inputStyle, ref, ...rest }: any, index: number) => (
    <input
      {...rest}
      ref={ref as React.RefObject<HTMLInputElement>}
      className={`custom-input-class ${inputStyle}`}
      placeholder={'123456'[index]}
      inputMode="numeric"
      pattern="[0-9]*"
      type="tel"
    />
  );

  const { mutate: verifyOTP, isPending: isLoading } = useMutation({
    mutationFn: verifyResetPasswordTokenApi,
    onSuccess: ({ message, entity }) => {
      saveOTPToContext(OTP);
      // localStorage.setItem('otp', OTP);
      const token = entity?.access;
      localStorage.setItem('access_token', token);
      localStorage.setItem('techrevolve__user', JSON.stringify(entity?.user))
      notification.success({ message: message || "Email Verified successfully" });
      navigate('/register/complete');

    },
    onError: (error: any) => {
      const message = error.response?.data?.message || "Invalid OTP. Please check and try again.";
      notification.error({ message });
    }
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // const email = localStorage.getItem('email');
    if (email && OTP.length === 6) {
      verifyOTP({ verification_code: OTP, email });
    } else {
      notification.error({ message: "Invalid OTP. Please check and try again." });
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleEmailChange = () => {
    localStorage.removeItem('email')
    navigate('/register')
  }
  const { isLoadingVerification, resendVerificationEmail } = useResendVerificationEmailApi({
    onSuccess: ({ message }: { message: string }) =>
      notification.success({ message: message }),
  });

  return (
    <AuthLayout>
      <div>
        <div className=" mt-32 text-left">
          <h1 className=" text-4xl text-dark mb-2 font-medium">Verify Email</h1>
          <p className=" text-lg text-dark/80 font-light mb-4"> Enter the code sent to <Link className="underline decoration-solid" to={""}>{email}</Link>. <br /><span onClick={handleEmailChange} className=" font-medium cursor-pointer">Change Email</span> </p>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            <OTPInput
              onChange={setOTP}
              value={OTP}
              numInputs={6}
              inputStyle="inputStyle"
              renderInput={renderInput}
            />
            <div className="flex flex-row items-center mt-8">
              <Button type="submit" isDisabled={OTP.length < 6} state='primary' label="Verify Email" isLoading={isLoading} />
              <Button
                type="button"
                state='tetiary'
                label="Resend Code"
                isLoading={isLoadingVerification}
                onClick={() => resendVerificationEmail(email)}
              />
            </div>
          </form>
        </div>
        <Modal
          title={false}
          open={isModalVisible}
          onCancel={handleModalCancel}
          closeIcon={<Close />}
          footer={null}
          width={450}
        >
          <h1 className=' pt-10 text-[32px]'>Verify Email</h1>
          <p className='text-sm font-light text-dark mb-2'>A code has been sent to your email address <span className='underline text-sm text-[#262626] font-medium mb-2 cursor-pointer' onClick={() => navigate(-1)}>{email}</span></p>
          <div onClick={handleEmailChange} className=' font-medium cursor-pointer'>Change Email</div>
          <Button onClick={handleModalCancel} className='mt-5' label='Continue' />
        </Modal>
      </div>
    </AuthLayout>
  )
}

export default VerifyEmailAuth